module.exports = __webpack_public_path__ + "static/img/icn_link_02.c29c924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icn_link_02.png
// module id = AO7Q
// module chunks = 10